import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Route, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { Drawer, List, ListItemLink } from "components/controls/widget";

import { path as pathHostovaniDlouhodoba } from "./hostovani-dlouhodoba/routes-path";
import { path as pathPartneri } from "./partneri/routes-path";
import { path as pathPrestupy } from "./prestupy/routes-path";
import { path as pathSoutezniUdaje, vysledkyPath as pathSoutezniUdajeVysledky } from "./soutezni-udaje/routes-path";
import { path as pathUpajeOp } from "./udaje-op/routes-path";
import { path as pathAnketyHlasovani } from "./ankety-a-hlasovani/routes-path";
import { path as pathPrispevky } from "./prispevky/routes-path";
import { RouteProps } from "./routes-path";
import ExpandableListItem from "components/controls/ExpandableListItem";



type Props = WithStyles<typeof styles> & RouteComponentProps<RouteProps>;


class SideMenu extends React.PureComponent<Props> {

    render() {

        const { classes, match } = this.props;

        const linkClasses = { gutters: classes.link };
        const getPath = (p: string) => (`${match.url}${p}`);
        const getStaticPath = (p: string) => {
            const { lang, idtClena } = match.params
            return '../../../../../../../' + lang + p + '/' + idtClena;

        }
        const getLink = (title: string, path: string, directLink?: boolean) => (<ListItemLink classes={{ gutters: classes.link }} button primary={title} to={path} directLink={directLink} />);
        const getNestedLink = (title: string, path: string, directLink?: boolean) => (<ListItemLink classes={{ gutters: classes.nested }} button primary={title} to={path} directLink={directLink} />);

        return <React.Fragment>
            <Drawer className={classes.drawer} variant="permanent" classes={{ paper: `${classes.drawerPaper}`, }} anchor="right">

                <List component="nav" >
                    {getLink('Osobní údaje', match.url)}
                    <ExpandableListItem button primary={'Soutěžní údaje'} classes={linkClasses}>
                        {getNestedLink('Základní údaje', getPath(pathSoutezniUdaje))}
                        {getNestedLink('Výsledky soutěží', getPath(pathSoutezniUdajeVysledky))}
                    </ExpandableListItem>
                    {getLink('Platby a příspěvky', getPath(pathPrispevky))}
                    {getLink('Partneři(ky)', getPath(pathPartneri))}
                    {getLink('Hostování dlouhodobá', getPath(pathHostovaniDlouhodoba))}
                    {getLink('Přestupy', getPath(pathPrestupy))}
                    <ExpandableListItem button primary={'Údaje OP'} classes={linkClasses}>
                        {getNestedLink('Licence', getPath(pathUpajeOp))}
                        {getNestedLink('Účast na školení', getStaticPath('/EvidOp/UcastNaSkoleni'), true)}
                        {getNestedLink('Registrace na soutěžích', getStaticPath('/EvidOp/RegistraceNaSoutezich'), true)}
                        {getNestedLink('Účast na soutěžích', getStaticPath('/EvidOp/UcastNaSoutezich'), true)}
                        {getNestedLink('Aktivita trenéra', getStaticPath('/EvidOp/AktivitaTrenera'), true)}
                    </ExpandableListItem>
                    {getLink('Ankety a hlasování', getPath(pathAnketyHlasovani))}
                </List>


            </Drawer>

        </React.Fragment>
    }
}


export const styles = (theme: Theme) => createStyles({
    drawer: {
        height: '100%',
        flexShrink: 0,
        width: 260,
    },
    drawerPaper: {
        position: 'relative',
        backgroundColor: theme.palette.info.light
    },
    link: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        // color: '#fff'
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
        paddingRight: theme.spacing.unit * 2,
    }
});


export default withStyles(styles)(withRouter(SideMenu));
